var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"margin-top12"},[_c('DescribeData',{attrs:{"describe":{
      label: '评估等级',
      text: _vm.valObj.text,
      color: _vm.valObj.color
    }}}),_c('div',{class:{
      'details-level': true,
      'no-answer': _vm.valObj.isEmpty
    }},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.valObj.desc || "候选人未作答"))]),(_vm.valObj.isEmpty)?_c('i',{staticClass:"iconfont iconfont-ai position-icon"},[_vm._v("")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }